import React from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { sichtbareReiter } from './reiter';

// W6 (#16 A2.6): Burger-Menü links auf Mobil — alle Ansichten mit denselben
// Rollen-Regeln wie die Desktop-Nav (#44). #562: aus Header.js gelöst, rendert
// nur; offen/zu hält der Header. Stile in kopfzeile.css. #568: ausgeblendete
// Reiter fehlen auch hier, „nur Symbol“ gilt im Menü nicht.
const BurgerMenue = ({ user, t, offen, setOffen, burgerRef, ausgeblendet }) => {
  const closeMenu = () => setOffen(false);
  return (
    <div className="kopf-burger" ref={burgerRef}>
      <button
        onClick={(e) => { e.preventDefault(); setOffen(prev => !prev); }}
        title={t('header.menu', 'Menü')} aria-label={t('header.menu', 'Menü')}
        aria-haspopup="menu"
        aria-expanded={offen ? 'true' : 'false'}
        className="kopf-knopf"
      >
        {/* color bleibt ausdruecklich: mit currentColor glaettet Chromium die
            Linienenden hier um bis zu 4/255 anders (Pixelvergleich #562) */}
        <Menu size={20} color="white" />
      </button>
      {offen && (
        <div className="kopf-burger-menue">
          {sichtbareReiter(user, 'burger', ausgeblendet).map(({ id, pfad, Icon, textKey, text }) => (
            <Link key={id} to={pfad} onClick={closeMenu} className="kopf-burger-eintrag">
              <Icon size={16} />
              <span>{t(textKey, text)}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default BurgerMenue;
